export default __webpack_public_path__ + "static/media/greenTick.f54d40ea.svg";